export enum RED_BALL_ATLAS_FRAMES {
  GRID_BACKGROUND = 'background-2.png',
  FOREGROUND = 'foreground.png',
  BALL = 'ball.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER = 'numbers/selected-transition-number.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND = 'numbers/selected-transition-background.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_HIT_TRANSITION = 'numbers/match-transition.png',
  NUMBER_GLOW = 'numbers/glow.png',
}

export enum RED_BALL_TEXTURE_KEYS {
  ATLAS = 'RED_BALL_ATLAS',
  NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER = 'RED_BALL_NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER',
  NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND = 'RED_BALL_NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND',
  NUMBER_DEFAULT = 'RED_BALL_NUMBER_DEFAULT',
  NUMBER_SYSTEM_SELECTED = 'RED_BALL_NUMBER_SYSTEM_SELECTED',
  NUMBER_PLAYER_SELECTED = 'RED_BALL_NUMBER_PLAYER_SELECTED',
  NUMBER_HIT = 'RED_BALL_NUMBER_HIT',
  NUMBER_HIT_TRANSITION = 'RED_BALL_NUMBER_HIT_TRANSITION',
}
